import {
    Show,
    SimpleShowLayout,
    TextField,
    DateField,
    FunctionField,
    TopToolbar,
    DeleteButton,
    useRecordContext,
} from 'react-admin';
import { Chip } from '@mui/material';

interface TokenRecord {
    isRevoked: boolean;
    isExpired: boolean;
    isValid: boolean;
}

const TokenShowActions = () => {
    const record = useRecordContext<TokenRecord>();
    return (
        <TopToolbar>
            {record && !record.isRevoked && (
                <DeleteButton label="Revoke" mutationMode="pessimistic" />
            )}
        </TopToolbar>
    );
};

export const BootstrapTokenShow = () => (
    <Show actions={<TokenShowActions />}>
        <SimpleShowLayout>
            <TextField source="name" />
            <FunctionField
                label="Status"
                render={(record: TokenRecord) => {
                    if (record.isRevoked) return <Chip label="Revoked" color="error" />;
                    if (record.isExpired) return <Chip label="Expired" color="default" />;
                    if (record.isValid) return <Chip label="Active" color="success" />;
                    return <Chip label="Inactive" color="default" />;
                }}
            />
            <FunctionField
                label="Usage"
                render={(record: { usageCount: number; maxUsage: number | null }) =>
                    `${record.usageCount} / ${record.maxUsage || 'Unlimited'}`
                }
            />
            <TextField source="rateLimitPerHour" label="Rate Limit (per hour)" />
            <DateField source="createdAt" showTime label="Created" />
            <DateField source="expiresAt" showTime label="Expires" />
            <TextField source="createdBy" label="Created By" />
        </SimpleShowLayout>
    </Show>
);
